import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const form1572Api = createApi({
  baseQuery,
  reducerPath: 'form1572Api',
  endpoints: builder => ({
    getForm1572Data: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_module_section }) => ({
        url: `${formatString(
          endPoints.From1572.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateSignForm1572: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, data, id, application_module_section }) => ({
        url: `${formatString(endPoints.From1572.updateSign, {
          key: urlKeys.id,
          value: id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createForm1572: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_module_section, data }) => ({
        url: `${formatString(
          endPoints.From1572.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateForm1572: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, data, application_module_section, id }) => ({
        url: `${formatString(
          endPoints.From1572.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.id, value: id }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishForm1572: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, data, application_module_section, id, isUpdate }) => ({
        url: `${formatString(endPoints.From1572.publish, {
          key: urlKeys.id,
          value: id
        })}?update=${isUpdate}&site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetForm1572DataQuery,
  useLazyUpdateSignForm1572Query,
  useLazyPublishForm1572Query,
  useLazyUpdateForm1572Query,
  useLazyCreateForm1572Query
} = form1572Api;
